﻿import {
  GroupSummariesCard,
  GroupSummariesCardContainer,
  GroupSummariesCardItemBackground, GroupSummariesCardItemContainer
} from "@securspace/securspace-ui-kit";
import React from 'react';
import {Skeleton} from "@mui/material";

const SupplierActivitySummariesGroupedLoader = () => {
  return <GroupSummariesCard>
    <GroupSummariesCardContainer>
      {
        Array.from({ length: 6}).map((_, index) => (
          <GroupSummariesCardItemContainer key={index}>
            <GroupSummariesCardItemBackground>
              <Skeleton variant="text" width="100%" height={30} />
              <Skeleton variant="text" width="80%" height={30} />
            </GroupSummariesCardItemBackground>
          </GroupSummariesCardItemContainer>
        ))
      }
    </GroupSummariesCardContainer>
  </GroupSummariesCard>
}

export { SupplierActivitySummariesGroupedLoader };
